import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const bookmarksApi = createApi({
  reducerPath: 'bookmarksApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Bookmarks', 'BookmarkItems'],
  endpoints: (builder) => ({
    getLists: builder.query({
      query: () => '/bookmarks',
      providesTags: ['Bookmarks'],
    }),
    getItems: builder.query({
      query: ({ listId, page = 1, perPage = 24 }) =>
        `/bookmarks/${listId}/items?page=${page}&per_page=${perPage}`,
      providesTags: (result, error, { listId }) => [{ type: 'BookmarkItems', id: listId }],
    }),
    addItem: builder.mutation({
      query: ({ listId, materialId }) => ({
        url: `/bookmarks/${listId}/items`,
        method: 'POST',
        body: { material_id: materialId },
      }),
      invalidatesTags: (result, error, { listId }) => [
        'Bookmarks',
        { type: 'BookmarkItems', id: listId },
      ],
    }),
    removeItem: builder.mutation({
      query: ({ listId, materialId }) => ({
        url: `/bookmarks/${listId}/items/${materialId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { listId }) => [
        'Bookmarks',
        { type: 'BookmarkItems', id: listId },
      ],
    }),
    createList: builder.mutation({
      query: ({ name, colorId }) => ({
        url: '/bookmarks',
        method: 'POST',
        body: { name, color_id: colorId },
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    updateList: builder.mutation({
      query: ({ listId, name, colorId }) => ({
        url: `/bookmarks/${listId}`,
        method: 'PATCH',
        body: { name, color_id: colorId },
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    deleteList: builder.mutation({
      query: ({ listId }) => ({
        url: `/bookmarks/${listId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bookmarks'],
    }),
    getAllItems: builder.query({
      query: ({ page = 1, perPage = 24 }) =>
        `/bookmarks/all/items?page=${page}&per_page=${perPage}`,
      providesTags: ['BookmarkItems'],
    }),
    getColors: builder.query({
      query: () => '/bookmarks/colors',
    }),
  }),
});

export const {
  useGetListsQuery,
  useGetItemsQuery,
  useGetAllItemsQuery,
  useAddItemMutation,
  useRemoveItemMutation,
  useCreateListMutation,
  useUpdateListMutation,
  useDeleteListMutation,
  useGetColorsQuery,
} = bookmarksApi;
